import axios from 'axios';
import { API_URL } from '../config';
import initialState from './initialState';
import { Warehouse } from '@mui/icons-material';

export const getReportsPZ04 = ({ reportPZ04 }) => reportPZ04;

const reducerName = 'reportsPZ04';
const createActionName = (name) => `app/${reducerName}/${name}`;

const LOAD_REPORTS_PZ04 = createActionName('LOAD_REPORTS_PZ04');
const ADD_REPORT_PZ04 = createActionName('ADD_REPORT_PZ04');
const EDIT_REPORT_PZ04 = createActionName('EDIT_REPORT_PZ04');
const DELETE_REPORT_PZ04 = createActionName('DELETE_REPORT_PZ04');

export const loadReportsPZ04 = (payload) => ({
  payload,
  type: LOAD_REPORTS_PZ04,
});
export const addReportPZ04 = (payload) => ({ payload, type: ADD_REPORT_PZ04 });
export const editReportPZ04 = (payload) => ({
  payload,
  type: EDIT_REPORT_PZ04,
});
export const deleteReportPZ04 = (payload) => ({
  payload,
  type: DELETE_REPORT_PZ04,
});

export const loadReportsPZ04Request = () => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/reports-pz04`, {
        withCredentials: true,
      });

      dispatch(loadReportsPZ04(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const loadReportsPZ04ByUserWarehouse = (activeWarehouse) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(
        `${API_URL}/reports-pz04/warehouse/${activeWarehouse}`,
        {
          withCredentials: true,
        },
      );

      dispatch(loadReportsPZ04(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const sendCreateMailPZ04 = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/reports-pz04/send-email`, data, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

// export const loadReportsPZ04ByUserRole = (userRole) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.get(`${API_URL}/reports-pz04/role/${userRole}`, {
//         withCredentials: true,
//       });

//       dispatch(loadReportsPZ04(res.data));
//       return res;
//     } catch (e) {
//       console.log(e.message);
//     }
//   };
// };

export const loadReportPZ04ByIdRequest = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.get(`${API_URL}/reports-pz04/${id}`, {
        withCredentials: true,
      });

      // dispatch(loadReportsPZ04(res.data));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

// export const loadReportPZ04ByQualityRequest = () => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.get(`${API_URL}/reports-pz04/quality`, {
//         withCredentials: true,
//       });
//       dispatch(loadReportsPZ04(res.data));
//       return res;
//     } catch (e) {
//       console.log(e.message);
//     }
//   };
// };

export const addReportPZ04Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.post(`${API_URL}/reports-pz04`, data, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

// export const sendCreateMail = (id) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.post(`${API_URL}/reports-PZ04/email/create`, id, {
//         withCredentials: true,
//       });

//       return res;
//     } catch (e) {
//       return e.response;
//     }
//   };
// };

// export const sendUpdateMail = (data) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.post(`${API_URL}/reports-PZ04/email/update`, data, {
//         withCredentials: true,
//       });

//       return res;
//     } catch (e) {
//       return e.response;
//     }
//   };
// };

export const updateReportPZ04Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/reports-pz04/${data.id}`, data, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const updateStatusPZ04 = (actionData) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(
        `${API_URL}/reports-pz04/status/${actionData.reportId}`,
        { statusReport: actionData.statusReport, qty: actionData.qty },
        {
          withCredentials: true,
        },
      );

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const createDecisionPZ04Request = (allData) => {
  return async (dispatch) => {
    const { statusReport, ...actionData } = allData;
    try {
      let res = await axios.post(`${API_URL}/actions-pz04`, actionData, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const deleteDecisionPZ04Request = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/${id}`, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

export const updateDecisionPZ04Request = (decisionData) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/actions-pz04`, decisionData, {
        withCredentials: true,
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

// export const deleteActionPZ04Request = (id) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.delete(`${API_URL}/actions/${id}`, {
//         withCredentials: true,
//       });
//       return res;
//     } catch (e) {
//       console.log(e.message);
//     }
//   };
// };

// export const updateOnlyDecisionPZ04Request = (decisionData) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.put(
//         `${API_URL}/decisions/only/${decisionData.id}`,
//         decisionData,
//         {
//           withCredentials: true,
//         },
//       );
//       return res;
//     } catch (e) {
//       return e.response;
//     }
//   };
// };

export const generateYellowPdfRequest = (dataToPDF) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${API_URL}/pdf-creator/yellow`,

          {
            context: {
              imageUrl: dataToPDF.image,
              dateCreated: dataToPDF.dateCreated,
              reason: dataToPDF.reason,
              productionLine: dataToPDF.productionLine,
              BBT: dataToPDF.BBT,
              material: dataToPDF.material,
              productionOrder: dataToPDF.productionOrder,
              reportNumber: dataToPDF.reportNumber,
              expiryDate: dataToPDF.expiryDate,
              batch: dataToPDF.batch,
              createdBy: dataToPDF.createdBy,
              currentUser: dataToPDF.currentUser,
              comments: dataToPDF.comments,
            },
          },

          { responseType: 'blob', withCredentials: true },
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const a = document.createElement('a');
          a.href = url;
          a.download = dataToPDF.reportNumber + '.pdf';
          document.body.appendChild(a);

          a.click();

          window.URL.revokeObjectURL(url);
        });
    } catch (e) {
      console.log(e);
    }
  };
};

export const generateRedPdfRequest = (dataToPDF) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${API_URL}/pdf-creator/red`,

          {
            context: {
              imageUrl: dataToPDF.image,
              dateCreated: dataToPDF.dateCreated,
              reason: dataToPDF.reason,
              productionLine: dataToPDF.productionLine,
              BBT: dataToPDF.BBT,
              material: dataToPDF.material,
              productionOrder: dataToPDF.productionOrder,
              reportNumber: dataToPDF.reportNumber,
              expiryDate: dataToPDF.expiryDate,
              batch: dataToPDF.batch,
              createdBy: dataToPDF.createdBy,
              currentUser: dataToPDF.currentUser,
              comments: dataToPDF.comments,
            },
          },

          { responseType: 'blob', withCredentials: true },
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));

          const a = document.createElement('a');
          a.href = url;
          a.download = dataToPDF.reportNumber + '.pdf';
          document.body.appendChild(a);

          a.click();

          window.URL.revokeObjectURL(url);
        });
    } catch (e) {
      console.log(e);
    }
  };
};

// export const generateRNPdfRequest = (dataToPDF) => {
//   return async (dispatch) => {
//     try {
//       console.log(dataToPDF);
//       await axios
//         .post(
//           `${API_URL}/pdf-creator/report`,

//           {
//             context: {
//               imageUrl: dataToPDF.image,
//               dateCreated: dataToPDF.dateCreated,
//               warehouse: dataToPDF.warehouse,
//               reportNumber: dataToPDF.reportNumber,
//               product: dataToPDF.product,
//               package: dataToPDF.package,
//               expiryDate: dataToPDF.expiryDate,
//               batch: dataToPDF.batch,
//               qty: dataToPDF.qty,
//               reason: dataToPDF.reason,
//               desNonCompliance: dataToPDF.desNonCompliance,
//               additionalDes: dataToPDF.additionalDes,
//               decisionMaker: dataToPDF.decisionMaker,
//               decisions: dataToPDF.decisions,
//             },
//           },

//           { responseType: 'blob', withCredentials: true },
//         )
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));

//           const a = document.createElement('a');
//           a.href = url;
//           a.download = `Raport niezgodności ${dataToPDF.reportNumber}.pdf`;
//           document.body.appendChild(a);

//           a.click();
//           console.log(url);

//           window.URL.revokeObjectURL(url);
//         });
//     } catch (e) {
//       console.log(e);
//     }
//   };
// };

// export const updateValueReportsPZ04Request = (id, data) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.put(`${API_URL}/reports-PZ04/value/${id}`, data, {
//         withCredentials: true,
//       });

//       return res;
//     } catch (e) {
//       return e.response;
//     }
//   };
// };

// export const updateValueDecisionPZ04Request = (valueData) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.put(
//         `${API_URL}/decisions/value/${valueData.id}`,
//         valueData,
//         {
//           withCredentials: true,
//         },
//       );

//       return res;
//     } catch (e) {
//       return e.response;
//     }
//   };
// };
export const addAttachmentsToReportPZ04Request = (data) => {
  return async (dispatch) => {
    try {
      const { files, ...otherData } = data;
      const fd = new FormData();
      for (let i = 0; i < files.length; i++) {
        fd.append('files', files[i]);
      }
      fd.append('reportId', otherData.reportId);
      let res = await axios.post(`${API_URL}/attachments/pz04`, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res;
    } catch (e) {
      return e.response;
    }
  };
};

export const editReportPZ04Request = (data) => {
  return async (dispatch) => {
    try {
      let res = await axios.put(`${API_URL}/reports-pz04/${data.id}`, data, {
        withCredentials: true,
      });

      return res;
    } catch (e) {
      return e.message.status;
    }
  };
};

// export const updateDecisionsPZ04Request = (decisionData) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.put(
//         `${API_URL}/decisions/${decisionData.id}`,
//         decisionData,
//         {
//           withCredentials: true,
//         },
//       );

//       return res;
//     } catch (e) {
//       return e.response;
//     }
//   };
// };

// export const generateRaportPZ04 = (data) => {
//   return async (dispatch) => {
//     try {
//       let res = await axios.post(`${API_URL}/reports-PZ04/reports`, data, {
//         withCredentials: true,
//         responseType: 'arraybuffer',
//       });

//       const blob = new Blob([res.data], {
//         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });

//       // Tworzenie linku do pobrania
//       const url = window.URL.createObjectURL(blob);

//       // Tworzenie linku do pobrania i kliknięcie w niego (rozpoczyna pobieranie)
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = 'Raport_PZ04.xlsx';
//       a.click();

//       // Zwolnij zasoby URL
//       window.URL.revokeObjectURL(url);
//       // return res;
//     } catch (e) {
//       return e.message.status;
//     }
//   };
// };

export const deleteReportPZ04Request = (id) => {
  return async (dispatch) => {
    try {
      let res = await axios.delete(`${API_URL}/reports-pz04/${id}`, {
        withCredentials: true,
      });
      dispatch(deleteReportPZ04(id));
      return res;
    } catch (e) {
      console.log(e.message);
    }
  };
};

const reportsPZ04Reducer = (statePart = initialState, action) => {
  switch (action.type) {
    case ADD_REPORT_PZ04:
      return [...statePart, action.payload];
    case EDIT_REPORT_PZ04:
      return statePart.map((el) =>
        el.id === action.payload.id ? action.payload : el,
      );
    case DELETE_REPORT_PZ04:
      return [...statePart.filter((el) => el.id !== action.payload)];
    case LOAD_REPORTS_PZ04:
      return action.payload;
    default:
      return statePart;
  }
};

export default reportsPZ04Reducer;
